var LayoutGriglia = (function () {

  /* ---------------------------------------------------------
  LAYOUT SINGLE PROGETTO
  --------------------------------------------------------- */

  var progetto = function (post, idEdizione) {

    output = '';

    output += '<article id="post-'+post.id+'" class="'+post.tile_classes+' blog-'+idEdizione+'">';
      if (post.tile_thumb_url !== '' && post.tile_thumb_url !== null && post.tile_thumb_url !== undefined) {
        output += '<a class="tile" href="'+post.permalink+'" style="background-image: url(\''+post.tile_thumb_url+'\');">';
      } else {
        output += '<a class="tile" href="'+post.permalink+'">';
      }
        output += '<div class="hover-txt">';

          output += '<div class="hover-content">';
            if (post.url_link_secondario_su_tile !== ''
              && post.url_link_secondario_su_tile !== null
              && post.url_link_secondario_su_tile !== undefined ) {
              output += '<div href="javascript:" onclick="window.open(\''+post.url_link_secondario_su_tile+'\');" target="_blank">';
                   output += '<h3 class="h5 me-auto mb-4">'+post.nome_promotore+' » '+post.testo_link_secondario_su_tile+'</h3>';
              output += '</div>';
            } else {
              if (post.nome_promotore) { output += '<h3 class="h5 me-auto mb-4">'+post.nome_promotore+'</h3>'; }
            }
            output += '<h2 class="h4 mb-0 fw-700">'+post.title+'</h2>';
          output += '</div>';

          output += '<div class="entra ms-0 mt-auto text-right">';
            output += '<span class="h5">';
              output += post.tipo_di_post;
            output += '</span>';
            if($('body').hasClass('pc_logged')){
              output += '<div class="icone d-flex flex-column">';
                output += post.love_button;
                output += '<i class="fal fa-sign-in"></i>';
              output += '</div>';
            } else {
              output += '<i class="fal fa-sign-in"></i>';
            }
          output += '</div>';

        output += '</div>';
      output += '</a>';
    output += '</article>';

    return output;

    /* ^ FINE PROGETTO ----------------------------------------- */
  };



  /* ---------------------------------------------------------
  LAYOUT SINGLE EVENTO
  --------------------------------------------------------- */

  var evento = function (post, idEdizione) {

    output = '';

    output += '<article id="post-'+post.id+'" class="'+post.tile_classes+' blog-'+idEdizione+'">';
      output += '<a class="tile d-flex" href="'+post.permalink+'">';

        output += '<div class="main-txt">';
          output += '<header class="entry-header">';
            output += '<h3 class="h4 mb-0 text-uppercase">'+post.title+'</h3>';
          output += '</header>';
        output += '</div>';

        output += '<div class="hover-txt">';
          output += '<div class="hover-content">';
            if (post.ente_curatore !== '') {
              output += '<span class="curatore h5 me-auto mb-4">'+post.ente_curatore+'</span>';
            }
            output += '<h3 class="h4 mb-4 mb-sm-5 fw-700">'+post.title+'</h3>';

            output += '<time class="giorno d-block">';
              output += post.giorno_evento;
            output += '</time>';
            if ( post.sala_evento !== '' ){
              output += '<span class="sala d-block">'+post.sala_evento+'</span>';
            }
            output += '<time class="ora mb-2 d-block">';
              output += post.inizio_evento + ' - ' + post.fine_evento;
            output += '</time>';
          output += '</div>';

          output += '<div class="entra ms-0 mt-auto text-right">';
            output += '<span class="h5">';
              output += post.tipo_di_post;
            output += '</span>';
            if($('body').hasClass('pc_logged')){
              output += '<div class="icone d-flex flex-column">';
                output += post.love_button;
                output += '<i class="fal fa-sign-in"></i>';
              output += '</div>';
            } else {
              output += '<i class="fal fa-sign-in"></i>';
            }
          output += '</div>';
        output += '</div>';

      output += '</a>';
    output += '</article>';

    return output;

    /* ^ FINE EVENTO ----------------------------------------- */
  };



  /* ---------------------------------------------------------
  LAYOUT SINGLE CONTRIBUTO
  --------------------------------------------------------- */

  var contributo = function (post, idEdizione) {

    output = '';

    output += '<article id="post-'+post.id+'" class="'+post.tile_classes+' blog-'+idEdizione+'">';
      if (post.tipo_contributo == 'video') {
        output += '<a class="tile" data-fancybox href="'+post.contributo_video+'" style="background-image: url(\''+post.tile_thumb_url+'\');">';
      } else {
        output += '<a class="tile" data-src="#contributo-'+post.id+'" data-fancybox href="javascript:;" style="background-image: url(\''+post.tile_thumb_url+'\');">';
      }

        output += '<div class="hover-txt">';
          output += '<div class="hover-content">';

            if (post.contributo_cognome !== ''
              && post.contributo_cognome !== null
              && post.contributo_cognome !== undefined ) {
                output += '<h3 class="h5 me-auto mb-4">'+post.contributo_nome+' '+post.contributo_cognome+'</h3>';
            }
            output += '<h2 class="h4 mb-0 fw-700">'+post.title+'</h2>';
          output += '</div>';

          output += '<div class="entra ms-0 mt-auto text-right">';
            output += '<span class="h5">';
              output += post.tipo_di_post;
            output += '</span>';
            if($('body').hasClass('pc_logged')){
              output += '<div class="icone d-flex flex-column">';
                output += post.love_button;
                output += '<i class="fal fa-sign-in"></i>';
              output += '</div>';
            } else {
              output += '<i class="fal fa-sign-in"></i>';
            }
          output += '</div>';
        output += '</div>';


        if (post.tipo_contributo == 'testo') {
          output += '<div class="fancy-modale-html" style="display: none;" id="contributo-'+post.id+'">';
            output += '<div class="container p-sm-5">';
              if (post.contributo_cognome !== ''
                && post.contributo_cognome !== null
                && post.contributo_cognome !== undefined ) {
                  output += '<h3 class="h3 me-auto mb-4">'+post.contributo_nome+' '+post.contributo_cognome+'</h3>';
              }
              output += '<h2 class="h2 mb-5 fw-700">'+post.title+'</h2>';
              output += '<div class="contenuto">';
                output += post.contributo_testo;
              output += '</div>';
            output += '</div>';
          output += '</div>';
        }

        output += '</div>';
      output += '</a>';
    output += '</article>';

    return output;

    /* ^ FINE CONTRIBUTO ----------------------------------------- */
  };


  return {
    progetto : progetto,
    evento : evento,
    contributo : contributo
  }


})();
